import { DialogDesignTokens } from "@primeuix/themes/types/dialog";

export const dialog: DialogDesignTokens = {
    root: {
        borderRadius: "12px",
    },
    css: () => {
        /**
         * Base Overrides for p-dialog
         */
        const base = `
            .p-dialog {
                box-shadow:
                    0 20px 25px -5px rgba(0, 0, 0, 0.1),
                    0 10px 10px -5px rgba(0, 0, 0, 0.04);

                .p-dialog-header {
                    border-bottom: 1px solid var(--p-azara-shade-200);
                    padding: 1.25rem 1.5rem;

                    .p-dialog-title {
                        font-weight: 600;
                        font-size: 1.25rem;
                        font-family: var(--p-font-family-sans);
                        color: var(--p-azara-blue-850);
                    }
                }

                .p-dialog-content {
                    padding: 1.5rem;
                }

                .p-dialog-footer {
                    border-top: 1px solid var(--p-azara-shade-200);
                    padding: 1.25rem 1.5rem;
                    background-color: var(--p-azara-shade-50);
                }
            }

            .p-dialog-mask.p-component-overlay {
                background-color: rgba(0, 0, 0, 0.5);
            }
        `;

        return base;
    },
};
